import { type OpenApiSchemaIntegrationStatus } from '#shared/api/schema';
import { getUserRequestContext } from '#shared/lib/context';

export const getTemporalIntegrationUrl = (integration: OpenApiSchemaIntegrationStatus) => {
    const { isInternalYandexUser } = getUserRequestContext();

    if (!isInternalYandexUser) {
        return null;
    }

    const temporalWorkflowUrl = integration.metadata?.temporal_workflow_url;

    if (!temporalWorkflowUrl) {
        return null;
    }

    return temporalWorkflowUrl;
};
